<template>
    <b-modal
        id="modal-change-coordinator"
        ref="modal-change-coordinator"
        centered
        ok-title="Aceptar"
        ok-variant="primary"
        cancel-title="Cancelar"
        title="Cambio de Coordinador del Sitio"
        @hidden="resetForm()"
        :ok-disabled="disableOkButton"
        @ok="onUpdate"
    >
        <h5><strong>Coordinador Actual</strong></h5>
        <p
            v-if="currentCoordinator"
            class="tall-line-height"
        >
            <strong>Número de Cédula: </strong>{{ currentCoordinator.identity_card }}<br />
            <strong>Nombre: </strong>{{ currentCoordinator.name }}<br />
            <strong>Apellido: </strong>{{ currentCoordinator.lastname }}<br />
        </p>

        <hr />

        <b-form id="change-coordinator-form" @submit.stop.prevent="onSubmit()">
            <b-form-group
                id="input-group-site-coordinator"
                label="Buscar Coordinador"
                label-for="input-site-coordinator"
                description="Busque y haga click en una de las opciones que se despliegan para seleccionar el coordinador deseado. Puede buscar por nombre, apellido o número de cédula."
            >
                <VueBootstrapTypeahead
                    id="input-site-coordinator"
                    v-model="coordinatorQuery"
                    placeholder="Busque un coordinador..."
                    :minMatchingChars="2"
                    :data="availableCoordinators"
                    :maxMatches="4"
                    :serializer="professor => `[${professor.identity_card}] ${professor.lastname}, ${professor.name}`"
                    @hit="selectCoordinator($event)"
                />
            </b-form-group>
        </b-form>

        <div v-if="selectedProfessor">
            <hr />
            <h5><strong>Nuevo Coordinador</strong></h5>
            <p class="tall-line-height">
                <strong>Número de Cédula: </strong>{{ selectedProfessor.identity_card }}<br />
                <strong>Nombre: </strong>{{ selectedProfessor.name }}<br />
                <strong>Apellido: </strong>{{ selectedProfessor.lastname }}<br />
            </p>
        </div>

    </b-modal>
</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
    name: 'ChangeSiteCoordinatorModal',
    components: {
        VueBootstrapTypeahead
    },
    data () {
        return {
            formDisabled: false,
            coordinatorQuery: '',
            availableCoordinators: [], // Retrieved dynamically from API
            selectedProfessor: null,
            form: {
                coordinatorId: null
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getActiveSiteIdentifiers'
        ]),
        currentCoordinator () {
            if (this.activeSite) {
                return this.activeSite.coordinator.user
            }
            return null
        },
        disableOkButton () {
            return this.formDisabled || !this.form.coordinatorId || this.currentCoordinator.id === this.form.coordinatorId
        }
    },
    watch: {
        coordinatorQuery (val, oldVal) {
            // Update the options every time the user changes the query.
            if (val) {
                this.getCoordinatorOptions(val)
            }
        }
    },
    methods: {
        ...mapActions([
            'readAllProfessors',
            'changeSiteCoordinator',
            'readCourseSiteByAcademicPeriod'
        ]),
        async onUpdate (bvModalEvt) {
            bvModalEvt.preventDefault() // Prevent modal from closing
            await this.onSubmit() // Trigger submit handler
        },
        async getCoordinatorOptions (query) {
            let professors = await this.readAllProfessors({ where: query, limit: 4 })
            this.availableCoordinators = professors
        },
        selectCoordinator (professor) {
            this.coordinatorQuery = ''
            this.selectedProfessor = professor
            this.form.coordinatorId = professor.id
        },
        resetForm () {
            this.coordinatorQuery = ''
            this.selectedProfessor = null
            this.form.coordinatorId = null
        },
        async onSubmit () {
            let loader = null
            // Create a const copy
            const payloadData = { ...this.form, courseSiteId: this.activeSite.id }
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                await this.changeSiteCoordinator(payloadData)
                // Reload the current active site data
                await this.readCourseSiteByAcademicPeriod({
                    courseCode: this.getActiveSiteIdentifiers.courseCode,
                    academicPeriod: this.getActiveSiteIdentifiers.academicPeriod
                })
                this.$root.successToast(`El coordinador ha sido cambiado exitosamente.`)
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-change-coordinator')
                })
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
